import {
  CONFIRMED_CREATE_CATEGORY_ACTION,
  CONFIRMED_DELETE_CATEGORY_ACTION,
  CONFIRMED_EDIT_CATEGORY_ACTION,
  CONFIRMED_GET_CATEGORIES,
} from "../actions/CategoryType";
import {
  getCategories,
  deleteCategory,
  createCategory,
  updateCategory,
  formatCategories,
} from "../../services/CategoryService";
import swal from "sweetalert";
import { handleError, handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";

// Get token from Redux or fallback to localStorage
function getAuthToken(getState) {
  const stateToken = getState().auth?.authKey;
  if (stateToken) return stateToken;

  const storedUser = localStorage.getItem("userDetails");
  return storedUser ? JSON.parse(storedUser).token : null;
}

// // GET all categories
// export function getCategoriesAction(pagination = true, pageid = 0,search_by = "", search_keyword = "",sort_order = "", sort_by = "") {
//   return async (dispatch, getState) => {
//     try {
//       const token = getAuthToken(getState);
//       const response = await getCategories(pagination, pageid,search_by, search_keyword,sort_order,sort_by, token);

//       if (response && response.status === 200 && response.data) {
//         if (response.data.status === "success" && response.data.data) {
//           const categories = formatCategories(response.data.data);
//           dispatch({ type: CONFIRMED_GET_CATEGORIES, payload: categories });
//         } else {
//           handleError("Failed to get categories: Server error");
//         }
//       } else {
//         handleError("Failed to get categories: Network error", "error");
//       }
//     } catch (error) {
//       console.error("API Error:", error.response || error);
//       showErrorAlert("Failed to get categories");
//     }
//   };
// }
export function getCategoriesAction(
  pagination = true,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState);
      const response = await getCategories(
        pagination,
        pageid,
        search_by,
        search_keyword,
        sort_by,
        sort_order,
        token
      );

      if (response && response.status === 200 && response.data) {
        if (response.data.status === "success" && response.data.data) {
          const categories = formatCategories(response.data.data);
          const num_rows = response.data.num_rows || 0;
          
          dispatch({
            type: CONFIRMED_GET_CATEGORIES,
            payload: {
              categories,
              num_rows,
            },
          });
        } else {
          handleError("Failed to get categories: Server error");
        }
      } else {
        handleError("Failed to get categories: Network error");
      }
    } catch (error) {
      console.error("API Error:", error.response || error);
      showErrorAlert("Failed to get categories");
    }
  };
}
// DELETE a category
export function deleteCategoryAction(category_id) {
  return async (dispatch) => {
    try {
      await deleteCategory(category_id);
      dispatch({
        type: CONFIRMED_DELETE_CATEGORY_ACTION,
        payload: category_id,
      });
      handleSuccess("Category deleted successfully!");
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to delete category");
    }
  };
}

// Update the updateCategoryAction
export function updateCategoryAction(category, categoryId, navigate) {
  return async (dispatch) => {
    try {
      const response = await updateCategory(category, categoryId);

      if (response?.data?.status === "success") {
        const updatedCategory = response.data.data;
        dispatch({
          type: CONFIRMED_EDIT_CATEGORY_ACTION,
          payload: updatedCategory,
        });
        handleSuccess("Category updated successfully!");
        if (navigate) navigate("/category-list");
      } else {
        showErrorAlert(
          response.data?.message || "Failed to update category",
        );
      }
    } catch (error) {
      console.error("Update Category Error:", error);
      showErrorAlert(
        error.response?.data?.message || "Failed to update category"
      );
    }
  };
}

// Update the createCategoryAction
export function createCategoryAction(categoryData, navigate) {
  return async (dispatch) => {
    try {
      const newCategory = {
        category_id: categoryData.category_id,
        category_name: categoryData.category_name,
        category_description: categoryData.category_description,
        category_status: categoryData.category_status,
      };
      const response = await createCategory(newCategory);

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_CREATE_CATEGORY_ACTION,
          payload: newCategory,
        });

        handleSuccess("Category created successfully!");
        if (navigate) navigate("/category-list");
      } else {
        showErrorAlert(
          response.data?.message || "Failed to create category"
        );
      }
    } catch (error) {
      console.error("Create Category Error:", error);
      showErrorAlert(
        error.response?.data?.message || "Failed to create category"
      );
    }
  };
}
